import { Improvements } from './improvements';
import { Urgency, UrgencyForPrequal } from './urgency';

export interface PropertySearchData {
  address: string;
  city: string;
  line_2: string;
  state: string;
  zipcode: string;
  fips?: string;
  apn?: string;
  promo_code?: string;
  ambassador_referral_code?: string;
  preferred_language?: PreferredLanguage;
}
export interface CommonPrequalification {
  property_search: PropertySearchData;
  user: {
    email: string;
    phone?: string;
    email_communication?: boolean;
  };
}

export interface CreateProjectPayload extends CommonPrequalification {
  metadata: {
    how_soon: Urgency;
    improvements: Improvements[];
  };
}

export interface CreateProjectPayloadPreQualification
  extends CommonPrequalification {
  metadata: {
    how_soon: UrgencyForPrequal;
    improvements: Improvements[];
  };
}

export enum PreferredLanguage {
  English = 'english',
  Espanol = 'spanish',
}
